/** @jsx jsx **/
// @ts-ignore
import { jsx, Box } from 'theme-ui'
import { useEffect, FC, useRef, useState, ReactNode, Fragment, RefObject } from 'react'

let globalId = 0

export type OnFormReadyType = (val: any, formRef: RefObject<HTMLDivElement>) => void

type Props = {
  formId: string
  onReady?: OnFormReadyType
  loading?: string | ReactNode
}

const KlaviyoForm: FC<Props> = ({ formId, onReady, loading }) => {
  const formRef = useRef<HTMLDivElement>(null)
  const [state, setState] = useState({
    loaded: false,
  })
  const findFormElement = () => {
    // protect against component unmounting before form is added
    if (!formRef.current) {
      return
    }

    const form = formRef.current.querySelector(`button`)
    if (form) {
      setState({ loaded: true })

      if (onReady) {
        onReady(form, formRef)
      }
    } else {
      setTimeout(findFormElement, 1)
    }
  }
  useEffect(() => {
    globalId++
    findFormElement()
    // }
  }, [])
  return (
    <div ref={formRef} id="klaviyoNewsletter" className={`klaviyo-form-${formId}`}>
      {!state.loaded && <Fragment>{loading}</Fragment>}
    </div>
  )
}

export default KlaviyoForm
